const recurringGenerationLocks = new Set<string>();

export const getRecurringGenerationLocks = () => recurringGenerationLocks;
